import { PureComponent } from "react";

import { BTPopover } from "@btnet/core-components/BTPopover";

import { PercentageDisplay } from "commonComponents/financial/PercentageDisplay/PercentageDisplay";

import "./TaxRateBreakdown.less";

import { BTTableCustom } from "../../../../commonComponents/btWrappers/BTTableCustom/BTTableCustom";
import { CurrencyDisplay } from "../../../../commonComponents/financial/CurrencyDisplay/CurrencyDisplay";
import { type TaxRateBreakdownInfo } from "../TaxRateBreakdown/TaxRateBreakdown.api.types";

interface ITaxRateBreakdownProps {
    /**
     * Tax rate breakdown info
     */
    taxRateBreakdownInfo: TaxRateBreakdownInfo;
}

export class TaxRateBreakdown extends PureComponent<ITaxRateBreakdownProps> {
    render() {
        const { taxRateBreakdownInfo } = this.props;
        const rowsToRender: JSX.Element[] = [];
        let index = 0;
        if (taxRateBreakdownInfo.taxRateBreakdownItems) {
            for (const item of taxRateBreakdownInfo.taxRateBreakdownItems) {
                rowsToRender.push(
                    <BTTableCustom.BodyRow className="FullBreakdownRow" key={index}>
                        <BTTableCustom.BodyCell className="TitleColumn">
                            <div data-testid={`taxRateName[${index}]`}>
                                {item.name}
                                {!item.isActive && " (Inactive)"}
                            </div>
                            <div
                                className="AppliedTaxDescription"
                                data-testid={`taxRateDescription[${index}]`}
                            >
                                <PercentageDisplay
                                    data-testid="taxPercentage"
                                    value={item.percentage}
                                    decimalScale={5}
                                    fixedDecimalScale={false}
                                />{" "}
                                tax on <CurrencyDisplay value={item.applicableAmount} />
                            </div>
                        </BTTableCustom.BodyCell>
                        <BTTableCustom.BodyCell className="FinancialColumn">
                            <CurrencyDisplay
                                value={item.taxAmount}
                                data-testid={`taxRateAmount[${index}]`}
                            />
                        </BTTableCustom.BodyCell>
                    </BTTableCustom.BodyRow>,
                );
                index++;
            }
        }
        if (taxRateBreakdownInfo.taxOverride !== 0) {
            rowsToRender.push(
                <BTTableCustom.BodyRow className="FullBreakdownRow" key={index}>
                    <BTTableCustom.BodyCell className="TitleColumn">
                        <div>
                            Tax override{" "}
                            <BTPopover
                                content={
                                    'If you applied a custom tax rate and then QBO invoice information changed, "Tax override" is a corrective measure to ensure both invoices\' taxes stay in sync.'
                                }
                                placement="right"
                            />
                        </div>
                    </BTTableCustom.BodyCell>
                    <BTTableCustom.BodyCell className="FinancialColumn">
                        <CurrencyDisplay
                            value={taxRateBreakdownInfo.taxOverride}
                            data-testid="taxOverride"
                        />
                    </BTTableCustom.BodyCell>
                </BTTableCustom.BodyRow>,
            );
            index++;
        }
        rowsToRender.push(
            <BTTableCustom.BodyRow className="FullBreakdownRow text-bold" key={index}>
                <BTTableCustom.BodyCell className="TitleColumn TotalBorder">
                    Total tax
                </BTTableCustom.BodyCell>
                <BTTableCustom.BodyCell className="FinancialColumn TotalBorder">
                    <CurrencyDisplay
                        value={taxRateBreakdownInfo.totalTax + taxRateBreakdownInfo.taxOverride}
                        data-testid="totalTax"
                    />
                </BTTableCustom.BodyCell>
            </BTTableCustom.BodyRow>,
        );

        return rowsToRender;
    }
}
